<template>
  <div class="container my-5">
  <h1 class="display-6 text-center">Our Teaching Approach</h1>
  <p class="lead text-center mb-5">
  Our teaching philosophy focuses on clarity, confidence, and critical thinking. We tailor our sessions to meet individual student needs, using real-world examples, active problem-solving, and personalised feedback to ensure lasting understanding — not just memorisation.
</p>

    <div class="accordion" id="teachingAccordion">
      <div class="accordion-item" v-for="(item, index) in teachingPoints" :key="index">
        <h2 class="accordion-header" :id="'heading' + index">
          <button
            class="accordion-button collapsed custom-accordion-btn"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + index"
            aria-expanded="false"
            :aria-controls="'collapse' + index"
          >
            {{ item.title }}
          </button>
        </h2>
        <div
          :id="'collapse' + index"
          class="accordion-collapse collapse"
          :aria-labelledby="'heading' + index"
          data-bs-parent="#teachingAccordion"
        >
          <div class="accordion-body">
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeachingView',
  data() {
    return {
     teachingPoints: [
  {
    title: 'Customised Lessons',
    description: 'Every student is unique, and so are their learning needs. We tailor our lessons to suit individual learning styles, focusing on concepts that need attention while building on existing strengths. This ensures optimal progress at a comfortable pace.'
  },
  {
    title: 'Subject Confidence Building',
    description: 'Struggling with algorithms or programming? We help students overcome barriers by breaking down complex topics, encouraging a positive mindset, and building confidence in their abilities to succeed.'
  },
  {
    title: 'Amplifying Your Interest',
    description: 
    `
    Passion drives performance. Through engaging teaching methods, real-world practical projects, and hands-on experiences, we help ignite or deepen an interest in Computer Science, making learning enjoyable and rewarding. 
    And we do this by indulging into scenarios that involve working with simulations, games and physical computing. 
    
    `
  },
  {
    title: 'Augmenting Your Knowledge',
    description: 'We expand students\' understanding beyond the classroom curriculum, offering insights into advanced concepts and trends. This not only aids in coursework but prepares them for future challenges.'
  },
  {
    title: 'Project Understanding',
    description: 'Navigating project work can be daunting. We guide students through project planning, execution, and presentation, ensuring clarity and mastery of essential skills.'
  },
  {
    title: 'Exams Preparations',
    description: 'Effective preparation is the key to success. We offer strategic revision plans, practice exams, and targeted support to boost confidence and achieve excellent results.'
  }
]
      
    };
  }
};
</script>

<style scoped>
.accordion-button {
  font-weight: 500;
  font-size: 1.05rem;
}

.custom-accordion-btn {
  background-color: #f8fdf9; /* light green/gray shade */
  color: #198754; /* Bootstrap green */
}

.custom-accordion-btn:not(.collapsed) {
  background-color: #198754;
  color: white;
}

.accordion-item {
  border: 1px solid #dee2e6;
  margin-bottom: 10px;
  border-radius: 6px;
  overflow: hidden;
}

.accordion-body {
  background-color: white;
  color: #333;
  font-size: 0.95rem;
}
</style>
